import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import AppLogin from "./components/HomeLogin.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import MdsirMixin from "./mixins/mdsirMixin";
import moment from "moment-timezone";
import VuetifyConfirm from "vuetify-confirm";
import VuetifyDialog from "vuetify-dialog";
import "vuetify-dialog/dist/vuetify-dialog.css";
import VueScrollTo from "vue-scrollto";
import VueHtmlToPaper from "vue-html-to-paper";
import { CONFIG } from "./mdsir/const";

Vue.use(VueScrollTo);
Vue.use(VuetifyDialog);

moment.tz.setDefault("Asia/Dhaka");
Vue.prototype.$moment = moment;

Vue.config.productionTip = false;
Vue.mixin(MdsirMixin);
Vue.use(VuetifyConfirm);

// const API_SERVER = `http://localhost/manpower-api`;
// const API_SERVER = `https://hal-api.habibassociates-bd.com`;
// const API_SERVER = `https://manpower-api.bitsbd.com`;
const API_SERVER = `https://hal-api.bitsbd.com`;

axios.defaults.baseURL = `${API_SERVER}/index.php/api`;
axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    if (error.response.status === 401) {
      store.dispatch("common/logOut");
      router.push("/");
    }
    return Promise.reject(error);
  }
);
Vue.prototype.$http = axios;
Vue.prototype.$API_SERVER = API_SERVER;
Vue.prototype.$UPLOAD_URL = `${API_SERVER}/index.php/api/upload`;
Vue.prototype.$UPLOAD1_URL = `${API_SERVER}/index.php/api/upload1`;
Vue.prototype.$CONFIG = CONFIG;

const AppFinal = store.getters["common/isLoggedIn"] ? App : AppLogin;

const VueHtmlToPaperOptions = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    // "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    // "https://unpkg.com/kidlat-css/css/kidlat.css",
    // 'print-styles.css',
    'printed.min.css',
    'mdsir-print-styles.css',
  ],
};
Vue.use(VueHtmlToPaper, VueHtmlToPaperOptions);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
